import React from 'react';
import { volumes } from '../data/landing';
const volumeGroups = [{
  title: 'Bases y registración',
  items: volumes.slice(0, 5)
}, {
  title: 'Cierre, análisis e integración',
  items: volumes.slice(5)
}];
export function LevelsSection() {
  return <section aria-labelledby="incluye" className="bg-white" data-id="element-113" data-mp="37dmct52nj5yf">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-114" data-mp="339mxuqx0sf76">
        <h2 id="incluye" className="mx-auto max-w-4xl text-center font-serif text-3xl font-black leading-[1.1] text-stone-900 sm:text-4xl lg:text-[2.9rem]" data-id="element-115" data-mp="3hah7fcvt0m7f">
          <span aria-hidden="true" data-id="element-116" data-mp="3cauvd6rppc07">📚 </span>Los 10 tomos que recibís en{' '}
          <span className="italic text-brand" data-id="element-117" data-mp="3qz8vh9xqumd2">MegaPack Contabilidad Lista</span>
        </h2>

        <div className="mt-14 grid gap-12 lg:grid-cols-2 lg:gap-10" data-id="element-118" data-mp="3m0xn73n3kjwy">
          {volumeGroups.map(group => <div key={group.title} data-id="element-119" data-mp="3ut2d1566x8h">
              <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-120" data-mp="3vudf5m6rjq7">
                <h3 className="font-serif text-xl font-bold text-stone-900 sm:text-2xl" data-id="element-121" data-mp="3v36vdmuw8176">{group.title}</h3>
                <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-stone-500" data-id="element-122" data-mp="19ctie40npf39">
                  {group.items.length} tomos
                </span>
              </div>

              <ol className="mt-6 space-y-4" data-id="element-123" data-mp="1j8o6henng2df">
                {group.items.map(volume => <li key={volume.code} className="rounded-2xl bg-stone-100 px-5 py-5 sm:px-6" data-id="element-124" data-mp="1o9bya2jpcn8p">
                    <span className="inline-flex rounded-full bg-slate-800 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-125" data-mp="1saxi67unm1se">
                      {volume.code}
                    </span>
                    <h4 className="mt-3 font-serif text-lg font-bold leading-snug text-stone-900" data-id="element-126" data-mp="21zxhxtgzd17n">{volume.title}</h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-stone-500" data-id="element-127" data-mp="26xz10eeep0j4">{volume.body}</p>
                  </li>)}
              </ol>
            </div>)}
        </div>
      </div>
    </section>;
}